<template lang="html">
  <div class="col-12">
    <div>
      <div v-if="$store.state.alertMsg !== ''" v-click-outside="clearAlertMsg"  class="alert alert-primary mx-0 py-1 text-small">{{ $store.state.alertMsg }}</div>
      <LoginTabs selected-page="login" />        
      <form class="form-create-login">
        <div class="form-group">
		  <GfInput
		    id="email"             
            type="email"
            initial-field-value="" 
            place-holder="Email"
            :has-error="validation.hasError('info_login.email')" 
            :error-text="validation.firstError('info_login.email')"            
            @valueChanged="(val) => info_login.email = val">
          </GfInput>
        </div>
        <div class="form-group">        
          <GfInput  
		  	id="password"           
            type="password"
            place-holder="Password"
            :has-error="validation.hasError('info_login.password')" 
            :error-text="validation.firstError('info_login.password')" 
            initial-field-value=""
            @valueChanged="(val) => info_login.password = val">
          </GfInput>          
        </div>
        <div class="row">
          <div class="col-12">
            <p class="font-weight-normal text-center w-100"><a 
              class="statusLogin primary-link" 
              @click="StatusCheckLogin('forgot')">Forgot your Password?</a></p>
          </div>
        </div>
        <div class="row">
          <div class="m-auto text-center text-danger pt-2">
            <h5  v-if="serverMessage !== ''">{{ serverMessage }}</h5>
          </div>
        </div>
        <div class="row mx-0 px-0 mb-3 container">          
          <TermsConditions button-that-agrees-text="Logging in, Registering or Creating a page" />
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-md-8 m-auto">
              <vue-recaptcha
                v-if="captchaPublicKey != ''" 
                ref="invisibleRecaptcha"
                :sitekey="captchaPublicKey"
                size="invisible"
                @verify="_recaptchaAsVerified"/>
              <button 
                id="btn-submit" 
                type="button" 
                :disabled="creatingPage || teamDetailsInValid()"
                class="btn btn-block font-weight-bold btn-driver" 
                @click="_login">Login & Create</button>
            </div>
            <Loader />
          </div>
        </div>
      </form>
    </div>

    <FacebookLogin 
      v-if="!inApp && !$store.state.accountLink"
      :app-id="facebookAppId" 
      :scope="facebookScope" 
    />
  </div>
</template>

<script>
import Vue from "vue";
import SimpleVueValidation from "simple-vue-validator";
import VueRecaptcha from "vue-recaptcha";
import FacebookLogin from "./FacebookLogin.vue";
import LoginTabs from "./LoginTabs.vue";
import axios from "axios";
import qs from "qs";
import Loader from "../inc/Loader.vue";
import TermsConditions from "./TermsConditions.vue";
import ClickOutside from "vue-click-outside";
import GfInput from "../inc/GfInput.vue";

var Validator = SimpleVueValidation.Validator;
Vue.use(SimpleVueValidation);

export default {
	components: {
		VueRecaptcha,
		FacebookLogin,
		Loader,
		LoginTabs,
		TermsConditions,
		GfInput,
	},

	directives: {
		ClickOutside,
	},

	data() {
		return {
			info_login: {
				email: "",
				password: "",
			},
			serverMessage: "",
			creatingPage: false,
			inApp: false,
		};
	},

	watch: {
		'$store.state.tokenErrorMessage': function() {
			this.serverMessage = this.$store.state.tokenErrorMessage.message;
		},
	},

	computed: {
		captchaPublicKey: {
			get: function () {
				return this.$store.state.captchaPublicKey
					? this.$store.state.captchaPublicKey
					: "";
			},
		},
		facebookAppId: {
			get: function () {
				return this.$store.state.facebookAppId;
			},
		},
		facebookScope: {
			get: function () {
				return this.$store.state.facebookScope;
			},
		},
	},

	created() {
		this.info_login.email = this.$store.state.login.email;
	},

	mounted() {
		var vm = this;
		this.$root.$on("loggedIn", this._onSuccessfulLogin);
		this.$root.$on("pageCreationFailed", (err) =>
			vm._onPageCreationFailed(err)
		);
		var ua = navigator.userAgent || navigator.vendor || window.opera;
		this.inApp = ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
	},

	methods: {
		StatusCheckLogin(type) {
			this.$emit("StatusCheckLogin", type);
		},

		teamDetailsInValid: function () {
			if (this.$store.state.pageType !== "createTeam") return false;
			return (
				this.$store.state.details_team.teamTarget === "" ||
				this.$store.state.details_team.teamName === ""
			);
		},

		_onSuccessfulLogin: function (username) {
			this.$root.$emit("createFrp");
		},

		_onPageCreationFailed: function (err) {
			this.serverMessage = err;
			this.creatingPage = false;
		},

		_recaptchaAsVerified: function (token) {
			this.recaptchaVerified = true;
			this.submit_form_login(token);
		},

		_login() {
			var vm = this;
			this.$validate().then(function (success) {
				if (success) {
					if (vm.captchaPublicKey !== "") {
						vm.$refs.invisibleRecaptcha.execute();
					} else {
						vm.submit_form_login();
					}
				}
			});
		},

		submit_form_login(captchaResult) {
			var vm = this;
			vm.$root.$emit("creatingPage");
			vm.creatingPage = true;
			vm.serverMessage = "";
			vm.$store.commit("setAlertMsg", "");
			if (vm.captchaPublicKey !== "") vm.$refs.invisibleRecaptcha.reset();

			if (vm.$store.state.shouldLinkAccount) {
				var vm = this;
				this.$gfLogger.logInfo(
					`Linking account using access token ${vm.$store.state.accessToken}`
				);
				axios({
					method: "post",
					url: "/account/link-account-facebook",
					data: qs.stringify({
						TuringTest: captchaResult,
						ReturnUrl: "/",
						Provider: "facebook",
						Data: vm.$store.state.accessToken,
						InFrame: true,
						UserName: vm.info_login.email,
						Password: vm.info_login.password
					}),
					headers: {
						"content-type":
							"application/x-www-form-urlencoded;charset=utf-8",
						"x-requested-with": "XMLHttpRequest"
					}
				}).then(function(data) {
					vm.$gfLogger.logInfo("Link account response:", data);
					if (data.data && data.data.success === true) {
						vm._onSuccessfulLogin(vm.info_login.email);
						return;
					} else {
						vm.$root.$emit(
							"pageCreationFailed",
							"The username / password specified is not valid. Please confirm details and try again."
						);
					}
				})
				.catch(function (error) {
					vm.$gfLogger.logInfo("Linking account error:", error);
					vm.$root.$emit(
						"pageCreationFailed",
						"Unknown error in creating the fundraising page. Please contact support."
					);
				});
			}
			else {
				axios
					.post("/account/logon", vm._constructFormData(captchaResult), {
						headers: {
							"Content-Type": "application/json",
						},
					})
					.then(function (res) {
						if (!res.data.TempData) {
							vm._onSuccessfulLogin(vm.info_login.email);
							return;
						}

						if (
							res.data.TempData["Status.Css"] &&
							res.data.TempData["Status.Css"].toLowerCase() == "error"
						) {
							vm.$root.$emit(
								"pageCreationFailed",
								res.data.TempData["Status.Message"]
							);
						}
					})
					.catch(function (error) {
						vm.$root.$emit(
							"pageCreationFailed",
							"Unknown error in creating the fundraising page. Please contact support."
						);
					});
			}

		},

		_constructFormData(captchaResult) {
			var vm = this;
			return {
				TuringTest: captchaResult,
				ReturnUrl: "/",
				InFrame: true,
				UserName: vm.info_login.email,
				Password: vm.info_login.password,
				Data: "",
			};
		},

		clearAlertMsg: function () {
			this.$store.commit("setAlertMsg", "");
		},
	},

	validators: {
		"info_login.email": function (value) {
			return Validator.value(value).required().email();
		},
		"info_login.password": function (value) {
			return Validator.value(value).required().minLength(4);
		},
	},
};
</script>

<style scoped>
.form-create-login .form-group label {
	font-size: 20px;
}
</style>